// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardNav_container__3sObQ"};